import Reveal from "@/components/Reveal";

const IMG =
  "https://images.unsplash.com/photo-1761069183527-a1a1414ee71f?q=80&w=1800&auto=format&fit=crop";

export default function Intro() {
  return (
    <section id="craft" data-testid="intro-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-start">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-clay mb-6">
              01 — The House
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
              Denizli has woven for
              <em className="italic text-clay"> a thousand years.</em>
              <br />
              We simply continue.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-smoke text-base sm:text-lg leading-relaxed max-w-xl">
              Nevatextile is a towel, peshtemal and bathrobe manufacturer based
              in Merkezefendi, Denizli — the historic heart of Turkish weaving.
              From Aegean cotton to hand-knotted fringes, every piece leaves
              our looms carrying a craft older than the city walls around it.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 grid grid-cols-3 gap-6 max-w-xl border-t border-line pt-8">
              {[
                ["100%", "Turkish cotton"],
                ["OEM", "Private label"],
                ["World", "wide export"],
              ].map(([big, small]) => (
                <div key={small} data-testid={`intro-stat-${small.replace(/\s/g, "-").toLowerCase()}`}>
                  <p className="font-serif text-3xl sm:text-4xl">{big}</p>
                  <p className="text-[11px] uppercase tracking-[0.2em] text-smoke mt-1">{small}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5 lg:mt-24">
          <Reveal delay={0.15} className="relative">
            <div className="overflow-hidden">
              <img
                src={IMG}
                alt="Cotton field at dusk"
                data-testid="intro-image"
                className="w-full h-[420px] sm:h-[520px] object-cover hover:scale-105 transition-transform duration-700 ease-out"
                loading="lazy"
              />
            </div>
            <p className="mt-4 text-[11px] uppercase tracking-[0.25em] text-smoke">
              Aegean cotton — where every thread begins
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
